import { render, staticRenderFns } from "./EditProducer.vue?vue&type=template&id=2743c19f&scoped=true&"
import script from "./EditProducer.vue?vue&type=script&lang=js&"
export * from "./EditProducer.vue?vue&type=script&lang=js&"
import style0 from "./EditProducer.vue?vue&type=style&index=0&id=2743c19f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743c19f",
  null
  
)

export default component.exports